import { render, staticRenderFns } from "./DepositAndWithdrawal.vue?vue&type=template&id=e743a4ea&"
import script from "./DepositAndWithdrawal.vue?vue&type=script&lang=js&"
export * from "./DepositAndWithdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports